import {
    BANK_ADMIN_CONFIRM_EMAIL_OTP,
    BANK_ADMIN_LOG_IN,
    CHANGE_BANK_ADMIN_PASSWORD,
    DELETE_USER_ID,
    FORGOT_BANK_ADMIN_PASSWORD,
    GET_ALL_ROLL_BY_PARAMETER,
    GET_ALL_USER_LIST_BY_BANK_ADMIN_ID,
    GET_ADVANCE_REPAYMENT_CALCULATION_PREVIEW,
    GET_APPLICANT_ADVANCE_HISTORY_BY_APPLICATION_ID,
    GET_APPLICANT_REPAYMENT_HISTORY_BY_APPLICATION_ID,
    GET_BANK_ADMIN_INFORMATION_BY_BANK_ADMIN_ID,
    GET_FIRM_ADMIN_ADVANCE_REPAYMENT_DATA_BY_SPONSER_ID,
    GET_FIRM_ADMIN_DATA_BY_SPONSER_ID,
    RESEND_EMAIL_WITH_LINK_AND_PASSCODE,
    SEND_VERIFY_EMAILOTP,
    UPDATE_BANK_ADMIN_DATA,
    UPDATE_USER_MANAGEMENT_DATA,
    GET_SPONSER_LIST_BY_EMAIL_AND_BANKADMINID,
    GET_FIRM_DROPDOWN_LIST_BY_EMAIL_AND_BANKADMINID,
    GET_SPONSER_DROPDOWN_LIST_BY_BANKERID,
    GET_TENANT_INFORMATION,
    GET_ACTUAL_TENANT_NAME,
    ADD_SPONSER_REPORT_DOCUMENT,
    GET_ALL_SPONSER_REPORT_LIST,
    GET_SPONSER_DROPDOWN_LIST_BY_BANKERID_V1,
    GET_FIRM_DROPDOWN_LIST_BY_BANKERID_V1,
    GET_LOAN_PROGRAME_TYPE_LIST_BY_FIRM_ID,
    GET_SUBMITTED_BATCHES_FOR_BANKER,
    CERTIFY_APPLICANT_ADVANCE_REPAYMENT_BATCH,
    GET_FIRM_ADMIN_DATA_BY_FIRM_AND_LOAN_PROGRAME_TYPE,
    GET_FIRM_ADMIN_ADVANCE_REPAYMENT_DATA_BY_FIRM_AND_LOAN_PROGRAME_TYPE,
    GET_FIRM_CREDIT_FACILITY_LIST_BY_USERID_AND_ROLEID,
    GET_SPONSER_FACILITY_LIST_BY_FIRM_ID_FOR_USER_ROLE,
} from "../constants/constants";
import { instance } from "./apiRequest";

let _BankAdminService = {
    async SendVerifyEmailOTP(obj) {
        return await instance.post(SEND_VERIFY_EMAILOTP, obj);
    },
    async ConfirmEmailOTP(obj) {
        return await instance.post(BANK_ADMIN_CONFIRM_EMAIL_OTP, obj);
    },
    async UpdateBankAdminData(reqObj) {
        return await instance.post(UPDATE_BANK_ADMIN_DATA, reqObj);
    },
    async bankAdminLogin(obj) {
        return await instance.post(BANK_ADMIN_LOG_IN, obj);
    },
    async ForgotBankAdminPassword(reqObj) {
        return await instance.post(FORGOT_BANK_ADMIN_PASSWORD, reqObj);
    },
    async getActualTenantName() {
        return await instance.get(GET_ACTUAL_TENANT_NAME);
    },
    async GetAllRollByParameter(rolltype) {
        return await instance.post(GET_ALL_ROLL_BY_PARAMETER, { rollType: rolltype });
    },
    async UpdateUserManagementData(reqObj) {
        return await instance.post(UPDATE_USER_MANAGEMENT_DATA, reqObj);
    },
    async GetAllUserListByBankAdminId({ BankAdminId, startDate = "", endDate = "", pageIndex = 1, pageSize = 10, searchTerm = "", sortBy = "id", sortAsc = false }) {
        return await instance.post(GET_ALL_USER_LIST_BY_BANK_ADMIN_ID, { bankAdminId: BankAdminId, pageIndex: pageIndex, pageSize: pageSize, searchTerm: searchTerm, sortBy: sortBy, sortAsc: sortAsc, startDate: startDate, endDate: endDate });
    },
    async deleteUserID(Id) {
        return await instance.post(DELETE_USER_ID, { id: Id });
    },
    async getBankAdminInformationByBankAdminId(bankAdminId) {
        return await instance.post(GET_BANK_ADMIN_INFORMATION_BY_BANK_ADMIN_ID, { bankAdminId: bankAdminId });
    },
    async ChangeBankAdminPassword(reqObj) {
        return await instance.post(CHANGE_BANK_ADMIN_PASSWORD, reqObj);
    },
    async ReSendEmailWithLinkAndPasscode(email, roleID) {
        return await instance.post(RESEND_EMAIL_WITH_LINK_AND_PASSCODE, { email: email, roleId: roleID });
    },
    // async getFirmAdminDataByFirmAdminId(FirmAdminId) {
    //     let url = GET_FIRM_ADMIN_DATA_BY_FIRM_ADMIN_ID + "?FirmAdminId=" + FirmAdminId;
    //     return await instance.get(url);
    // },

    async getFirmAdminDataBySponserId(sponserId) {
        return await instance.post(GET_FIRM_ADMIN_DATA_BY_SPONSER_ID, { sponserId: sponserId });
    },

    // async getFirmAdminAdvanceRepaymentDataByFirmAdminId(FirmAdminId) {
    //     let url = GET_FIRM_ADMIN_ADVANCE_REPAYMENT_DATA_BY_FIRM_ADMIN_ID + "?FirmAdminId=" + FirmAdminId;
    //     return await instance.get(url);
    // },

    async getFirmAdminAdvanceRepaymentDataBySponserId(SponserId) {
        return await instance.post(GET_FIRM_ADMIN_ADVANCE_REPAYMENT_DATA_BY_SPONSER_ID, { sponserId: SponserId });
    },

    async getFirmAdminAdvanceRepaymentDataByFirmAndLoanProgrameType(firmId, loanProgrameTypeId, sponserId = null) {
        return await instance.post(GET_FIRM_ADMIN_ADVANCE_REPAYMENT_DATA_BY_FIRM_AND_LOAN_PROGRAME_TYPE, { firmId: firmId, loanProgrameTypeId: loanProgrameTypeId, sponserId: sponserId });
    },

    async getAdvanceRepaymentCalculationPreview(reqObj) {
        return await instance.post(GET_ADVANCE_REPAYMENT_CALCULATION_PREVIEW, reqObj);
    },

    async getApplicantAdvanceHistoryByApplicationId(applicationId) {
        return await instance.post(GET_APPLICANT_ADVANCE_HISTORY_BY_APPLICATION_ID, { applicationId: applicationId });
    },

    async getApplicantRepaymentHistoryByApplicationId(applicationId) {
        return await instance.post(GET_APPLICANT_REPAYMENT_HISTORY_BY_APPLICATION_ID, { applicationId: applicationId });
    },

    async getSponserListByEmailAndBankAdminId(emailId, bankAdminId) {
        return await instance.post(GET_SPONSER_LIST_BY_EMAIL_AND_BANKADMINID, { email: emailId, bankAdminId: bankAdminId });
    },

    async getFirmDropdownListByEmailAndBankAdminId(emailId, bankAdminId) {
        return await instance.post(GET_FIRM_DROPDOWN_LIST_BY_EMAIL_AND_BANKADMINID, { email: emailId, bankAdminId: bankAdminId });
    },

    async getSponserDropdownListByBankerId(bankerId, bankAdminId,roleId, isBanker = false) {
        return await instance.post(GET_SPONSER_DROPDOWN_LIST_BY_BANKERID, { bankerId: bankerId, bankAdminId: bankAdminId, roleId: roleId, isBanker: isBanker });
    },

    async getSponserDropdownListByBankerIdV1(bankerId, roleId, isBanker = false) {
        return await instance.post(GET_SPONSER_DROPDOWN_LIST_BY_BANKERID_V1, { bankerId: bankerId, roleId: roleId, isBanker: isBanker });
    },

    async getFirmDropdownListByBankerIdV1(bankerId, roleId, isBanker = false) {
        return await instance.post(GET_FIRM_DROPDOWN_LIST_BY_BANKERID_V1, { bankerId: bankerId, roleId: roleId, isBanker: isBanker });
    },

    async getLoanProgrameTypeListByFirmId(firmId, identity = {}) {
        const { bankerId, roleId, isBanker, email, bankAdminId } = identity;
        let body = { firmId: firmId };
        if (bankerId) body.bankerId = bankerId;
        if (roleId !== undefined && roleId !== null) body.roleId = roleId;
        if (isBanker !== undefined) body.isBanker = isBanker;
        if (email) body.email = email;
        if (bankAdminId) body.bankAdminId = bankAdminId;
        return await instance.post(GET_LOAN_PROGRAME_TYPE_LIST_BY_FIRM_ID, body);
    },

    // Certify & Submit Batch (CertifyBatch.md Section 5.4): Senior Private Banker/Underwriter
    // Banker's "Submitted batches awaiting certification" list and certify action.
    async getSubmittedBatchesForBanker(bankerId, roleId, isBanker, batchType) {
        return await instance.post(GET_SUBMITTED_BATCHES_FOR_BANKER, { bankerId: bankerId, roleId: roleId, isBanker: isBanker, batchType: batchType });
    },

    async certifyApplicantAdvanceRepaymentBatch(batchNumber, batchType, certifiedBy) {
        return await instance.post(CERTIFY_APPLICANT_ADVANCE_REPAYMENT_BATCH, { batchNumber: batchNumber, batchType: batchType, certifiedBy: certifiedBy });
    },

    async getFirmAdminDataByFirmAndLoanProgrameType(firmId, loanProgrameTypeId, sponserId = null) {
        return await instance.post(GET_FIRM_ADMIN_DATA_BY_FIRM_AND_LOAN_PROGRAME_TYPE, { firmId: firmId, loanProgrameTypeId: loanProgrameTypeId, sponserId: sponserId });
    },

    async getFirmCreditFacilityListByUserIdAndRoleId(userId, roleId) {
        return await instance.post(GET_FIRM_CREDIT_FACILITY_LIST_BY_USERID_AND_ROLEID, { bankerId: userId, roleId: roleId });
    },

    async getSponserFacilityListByFirmIdForUserRole(firmId, userId, roleId) {
        return await instance.post(GET_SPONSER_FACILITY_LIST_BY_FIRM_ID_FOR_USER_ROLE, { firmId: firmId, userId: userId, roleId: roleId });
    },

    async getTenantInformation() {
        return await instance.get(GET_TENANT_INFORMATION);
    },

    async addSponserReportDucument(reqObj) {
        return await instance.post(ADD_SPONSER_REPORT_DOCUMENT, reqObj);
    },

    async getAllSponserReportList({ sponserId, documentTypeId = 0, firmId, loanProgrameTypeId, pageIndex = 1, pageSize = 10, searchTerm = "", sortBy = "Id", sortAsc = true }) {
        let body = { pageIndex: pageIndex, pageSize: pageSize, searchTerm: searchTerm, sortBy: sortBy, sortAsc: sortAsc, documentTypeId: documentTypeId };
        if (sponserId) {
            body.sponserId = sponserId;
        }
        if (firmId) {
            body.firmId = firmId;
        }
        if (loanProgrameTypeId) {
            body.loanProgrameTypeId = loanProgrameTypeId;
        }
        return await instance.post(GET_ALL_SPONSER_REPORT_LIST, body);
    },

}
export default _BankAdminService;